'use-client';
import TestComp from '../../TestComp';

export default TestComp;
